import { createAppStore } from './slices/app-store.js';
import { createChartStore } from './slices/chart-store.js';
import { createConnectionStore, } from './slices/connection-store.js';
import { createDebugStore, } from './slices/debug-store.js';
import { createLiveStore, } from './slices/live-store.js';
import { createModeStore } from './slices/mode-store.js';
import { createSweepStore } from './slices/sweep-store.js';
import { createTraceStore } from './slices/trace-store.js';
export async function createAppState(deps) {
    const app = createAppStore();
    const connection = createConnectionStore({ io: deps.io });
    const sweep = createSweepStore({ io: deps.io });
    const mode = createModeStore({ io: deps.io });
    const live = createLiveStore();
    const trace = createTraceStore({ traceRepo: deps.traceRepo });
    const debug = createDebugStore({ logRepo: deps.logRepo });
    const chart = createChartStore();
    // SigGenStore deferred to Plan #8 (requires IoApi.setSigGen).
    const unsubs = [
        await deps.io.onStatus((s) => connection.internal._updateStatus(s)),
        await deps.io.onFrame((f) => live.internal._ingestFrame(f)),
        await deps.io.onLog((e) => debug.internal._appendLocal(e)),
    ];
    app.actions.setBootPhase('starting');
    void trace.actions.hydrate().then((r) => {
        if (r.kind === 'err') {
            app.actions.setHydrationError(r.error.message);
        }
        app.actions.setBootPhase('hydrated');
    });
    return {
        stores: { app, connection, sweep, mode, live, trace, debug, chart },
        async dispose() {
            for (const unsub of unsubs)
                await unsub();
            debug.actions.stopFlush();
        },
    };
}
//# sourceMappingURL=app-state.js.map